import { useEffect, useState } from "react";

/**
 * The current time, refreshed every `intervalMs` and whenever the page comes
 * back into view.
 *
 * The second trigger matters on a phone: a backgrounded tab's timers are
 * throttled or frozen, so without it somebody who unlocks their phone at 10:02
 * would read the 09:00 session as still running until the next tick.
 */
export function useNow(intervalMs = 30_000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const tick = () => setNow(new Date());
    const timer = window.setInterval(tick, intervalMs);
    const onVisibility = () => {
      if (document.visibilityState === "visible") tick();
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [intervalMs]);

  return now;
}
